import axios from 'axios';
import { GS_BASE_URL, unwrap } from './gsIntg';

// createTemplate/updateTemplate share this: file goes in as "header_examples"; every other
// payload key is skipped when nullish, else stringified (object/array -> JSON.stringify, else String).
function buildTemplateFormData(payload, file) {
  const body = new FormData();
  body.append('header_examples', file);
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    body.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
  });
  return body;
}

export async function createTemplate(orgId, channelId, payload, file) {
  const url = `${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/template`;
  const res = file ? await axios.post(url, buildTemplateFormData(payload, file)) : await axios.post(url, payload);
  return unwrap(res);
}

export async function updateTemplate(orgId, channelId, templateId, payload, file) {
  const url = `${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/template/${templateId}`;
  const res = file ? await axios.put(url, buildTemplateFormData(payload, file)) : await axios.put(url, payload);
  return unwrap(res);
}

export async function deleteTemplate(orgId, channelId, templateId, type, options = {}) {
  if (!type) throw new Error('type is required to delete a template');
  const { deleteFromDbOnly, agent } = options;
  const res = await axios.delete(
    `${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/template/${templateId}`,
    { params: { type, deleteFromDbOnly, agent } }
  );
  return unwrap(res);
}

export async function getDeletedTemplates(orgId, channelId, query) {
  const res = await axios.get(`${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/deleted-templates`, {
    params: { ...query },
  });
  return unwrap(res);
}

export async function cloneTemplates(orgId, channelId, payload) {
  const res = await axios.post(`${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/template/clone`, payload);
  return unwrap(res);
}

export async function archiveTemplates(orgId, channelId, payload) {
  const res = await axios.post(`${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/template/archive`, payload);
  return unwrap(res);
}

export async function unarchiveTemplates(orgId, channelId, payload) {
  const res = await axios.post(`${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/template/unarchive`, payload);
  return unwrap(res);
}

export async function uploadTemplateMedia(orgId, channelId, file, options = {}) {
  const { async, mediaUrl } = options;
  const body = new FormData();
  // This endpoint's file part is named "file" — template create/update use "header_examples" instead; the two genuinely differ.
  body.append('file', file);
  if (async !== undefined && async !== null) body.append('async', String(async));
  if (mediaUrl !== undefined && mediaUrl !== null) body.append('mediaUrl', String(mediaUrl));
  const res = await axios.post(`${GS_BASE_URL}whatsapp/enterprise/${orgId}/channel/${channelId}/media`, body);
  return unwrap(res);
}

// gs-intg's wrapper turns an upstream HTTP-200-with-error into a real HTTP 400, so the message
// has to be read back out of err.response instead of a thrown API error object.
export function templateErrorMessage(err) {
  const value = err.response?.data?.details || err.response?.data?.message || err.message || 'Template request failed';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return value;
}
